import Vue from 'vue';

import { EmployerType as EMPLOYER_TYPE } from './constants';

/* eslint-disable no-param-reassign */
export function formatMoney(n) {
  const c = 0;
  const d = '';
  const t = ',';
  const s = n < 0 ? '-' : '';
  const intI = parseInt(n = Math.abs(+n || 0).toFixed(c), 10);
  const i = `${intI}`;

  let j = i.length;
  j = j > 3 ? j % 3 : 0;

  const part1 = s;
  const part2 = (j ? i.substr(0, j) + t : '');
  const part31 = `$1${t}`;
  const part3 = i.substr(j).replace(/(\d{3})(?=\d)/g, part31);
  const part4 = d + Math.abs(n - i).toFixed(c).slice(2);

  return `${part1}${part2}${part3}${part4}`;
}

export function formatMoney2(n) {
  const c = 0;
  const d = '';
  const t = ',';
  const s = n < 0 ? '-' : '';
  const intI = parseInt(Math.abs(+n || 0).toFixed(c), 10);
  const i = `${intI}`;

  let j = i.length;
  j = j > 3 ? j % 3 : 0;

  const part1 = s;
  const part2 = (j ? i.substring(0, j) + t : '');
  const part31 = `$1${t}`;
  const part3 = i.substring(j).replace(/(\d{3})(?=\d)/g, part31);
  const part4 = d + Math.abs(n - i).toFixed(2).slice(1);

  return `${part1}${part2}${part3}${part4}`;
}
/* eslint-disable */

export function formatPercent(value, fixed = 2) {
  return parseFloat(value * 100).toFixed(fixed);
}

export function roundToNearest(value, round) {
  const roundTo = 1 / round;
  return Math.round(value * roundTo) / roundTo;
}

// Filters
Vue.filter('same', val => val);
Vue.filter('currencyDisplay', val => `$${formatMoney(val)}`);
Vue.filter('currencyDisplay2', val => `$${formatMoney2(val)}`);
Vue.filter('percent', val => `${(val * 1).toFixed(2)}%`);
Vue.filter('percentageDisplay', val => `${(val * 100).toFixed(2)}%`);
Vue.filter('boolYesNo', (val) => val ? 'Yes' : 'No');
Vue.filter('numYesNo', (val) => val > 0 ? 'Yes' : 'No');

Vue.filter('memberType', (val) => {
  switch (val) {
    case EMPLOYER_TYPE.GOVERNMENT:
      return 'Queensland Government';
    case EMPLOYER_TYPE.NON_GOVERNMENT:
      return 'Non Government';
    case EMPLOYER_TYPE.SELF_OR_NOT_EMPLOYED:
      return 'Self / Not employed';
    default:
      return 'Unknown';
  }
});

Vue.filter('investmentMix', (val) => {
  switch (val) {
    case 1:
      return 'Low risk';
    case 2:
      return 'Medium / Low risk';
    case 3:
      return 'Medium risk';
    case 4:
      return 'Medium / High risk';
    case 5:
      return 'High risk';
    default:
      return 'Unknown';
  }
});

Vue.filter('runFilter', (val, filter) => {
  if (!filter) {
    return val;
  }

  return Vue.filter(filter)(val);
});
